"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import AllowlistToolCommonModalWrapper, { AllowlistToolModalSize } from "@/components/allowlist-tool/common/modals/AllowlistToolCommonModalWrapper";
import CreateDistributionPlan from "./CreateDistributionPlan";
import { useRouter } from "next/navigation";
export default function DistributionPlanToolCreatePlan() {
  const $ = _c(10);
  const [isNewPlanModalOpen, setIsNewPlanModalOpen] = useState(false);
  const router = useRouter();
  let t0;
  if ($[0] !== router) {
    t0 = distributionPlanId => {
      router.push(`/emma/plans/${distributionPlanId}`);
    };
    $[0] = router;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const onSuccess = t0;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setIsNewPlanModalOpen(true);
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <button onClick={t1} type="button" className="tw-inline-flex tw-items-center tw-gap-x-2 tw-px-4 tw-py-3 tw-bg-primary-500 tw-text-white tw-font-medium tw-text-sm tw-border tw-border-primary-500 tw-rounded-lg hover:tw-bg-primary-600 hover:tw-border-primary-600 tw-transition tw-duration-300 tw-ease-out"><svg className="tw-h-5 tw-w-5 -tw-ml-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 5V19M5 12H19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>Create new</button>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setIsNewPlanModalOpen(false);
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== onSuccess) {
    t4 = <CreateDistributionPlan onSuccess={onSuccess} />;
    $[5] = onSuccess;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== isNewPlanModalOpen || $[8] !== t4) {
    t5 = <>{t2}<AllowlistToolCommonModalWrapper showModal={isNewPlanModalOpen} onClose={t3} title="Create new Distribution plan" modalSize={AllowlistToolModalSize.X_LARGE} showTitle={false}>{t4}</AllowlistToolCommonModalWrapper></>;
    $[7] = isNewPlanModalOpen;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}